import { pathOr } from 'ramda';

export const DATADOG_RUM_ELIGIBILITY_REASONS = {
  PROVIDER_PUBLISHED_LISTING: 'provider_published_listing',
  CUSTOMER_LEAD_ADD_TO_CART: 'customer_lead_add_to_cart',
  CUSTOMER_LEAD_RESERVE_CLICK: 'customer_lead_reserve_click',
};

export const DATADOG_RUM_SEGMENTS = {
  OWNER: 'owner',
  CUSTOMER_LEAD: 'customer-lead',
};

const LEGACY_CUSTOMER_LEAD_REASONS = new Set([
  'booking_transaction_started',
  'booking_enquiry_started',
]);

export const getDatadogRumPrivateData = (user) =>
  pathOr({}, ['attributes', 'profile', 'privateData'], user);

export const isDatadogRumUserEligible = (user) => {
  const privateData = getDatadogRumPrivateData(user);
  return privateData.datadogRumEnabled === true;
};

export const getDatadogRumUserSegmentId = (user) => {
  const privateData = getDatadogRumPrivateData(user);
  const segmentId = privateData.datadogRumSegmentId;
  const reason = privateData.datadogRumEligibilityReason;

  if (segmentId === DATADOG_RUM_SEGMENTS.OWNER) {
    return DATADOG_RUM_SEGMENTS.OWNER;
  }
  if (segmentId === DATADOG_RUM_SEGMENTS.CUSTOMER_LEAD) {
    return DATADOG_RUM_SEGMENTS.CUSTOMER_LEAD;
  }
  if (reason === DATADOG_RUM_ELIGIBILITY_REASONS.PROVIDER_PUBLISHED_LISTING) {
    return DATADOG_RUM_SEGMENTS.OWNER;
  }
  if (LEGACY_CUSTOMER_LEAD_REASONS.has(reason)) {
    return DATADOG_RUM_SEGMENTS.CUSTOMER_LEAD;
  }

  return null;
};

export const getDatadogRumStateSegmentId = (state) => {
  const currentUserHasPublishedListings = pathOr(
    false,
    ['user', 'currentUserHasPublishedListings'],
    state
  );
  if (currentUserHasPublishedListings) {
    return DATADOG_RUM_SEGMENTS.OWNER;
  }

  return getDatadogRumUserSegmentId(pathOr(null, ['user', 'currentUser'], state));
};

export const isDatadogRumStateEligible = (state) => {
  const isAuthenticated = pathOr(false, ['Auth', 'isAuthenticated'], state);
  const currentUser = pathOr(null, ['user', 'currentUser'], state);
  const segmentId = getDatadogRumStateSegmentId(state);
  return Boolean(
    isAuthenticated && currentUser && (segmentId || isDatadogRumUserEligible(currentUser))
  );
};
